// extracted by mini-css-extract-plugin
module.exports = {"soundplayerButton":"soundPlayerButton-module--soundplayerButton--3YJs-"};